<div class="m-2 container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8">
      <form [formGroup]="vehicleForm" (ngSubmit)="onSubmit()">
        <p-card class="p-4">
          <ng-template #header>
            <div class="flex align-items-center justify-content-between">
              <h2 class="m-0 text-2xl font-bold">{{ pageTitle }}</h2>
            </div>
          </ng-template>
          <!-- Informações Básicas -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações Básicas</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="model" class="block text-sm font-medium mb-2">
                  Modelo <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  pInputText 
                  id="model"
                  formControlName="model"
                  placeholder="Ex: Civic, Corolla"
                  class="w-full"
                  [class.p-invalid]="vehicleForm.get('model')?.invalid && vehicleForm.get('model')?.touched" />
                <small 
                  *ngIf="getFieldError('model')" 
                  class="p-error block mt-1">
                  {{ getFieldError('model') }}
                </small>
              </div>
              
              <div class="field">
                <label for="brand" class="block text-sm font-medium mb-2">
                  Marca <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  pInputText 
                  id="brand"
                  formControlName="brand"
                  placeholder="Ex: Honda, Toyota"
                  class="w-full"
                  [class.p-invalid]="vehicleForm.get('brand')?.invalid && vehicleForm.get('brand')?.touched" />
                <small 
                  *ngIf="getFieldError('brand')" 
                  class="p-error block mt-1">
                  {{ getFieldError('brand') }}
                </small>
              </div>
            </div>
          </div>

          <p-divider />

          <!-- Informações Técnicas -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações Técnicas</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="licensePlate" class="block text-sm font-medium mb-2">
                  Placa <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  pInputText 
                  id="licensePlate"
                  formControlName="licensePlate"
                  placeholder="Ex: ABC-1234"
                  class="w-full"
                  [class.p-invalid]="vehicleForm.get('licensePlate')?.invalid && vehicleForm.get('licensePlate')?.touched" />
                <small 
                  *ngIf="getFieldError('licensePlate')" 
                  class="p-error block mt-1">
                  {{ getFieldError('licensePlate') }}
                </small>
              </div>
              
              <div class="field">
                <label for="seatCount" class="block text-sm font-medium mb-2">
                  Número de Assentos <span class="text-red-500">*</span>
                </label>
                <p-inputNumber 
                  id="seatCount"
                  formControlName="seatCount"
                  placeholder="Ex: 4"
                  [min]="1"
                  [max]="50"
                  [showButtons]="true"
                  class="w-full"
                  [class.p-invalid]="vehicleForm.get('seatCount')?.invalid && vehicleForm.get('seatCount')?.touched" />
                <small 
                  *ngIf="getFieldError('seatCount')" 
                  class="p-error block mt-1">
                  {{ getFieldError('seatCount') }}
                </small>
              </div>
            </div>
          </div>

          <p-divider />

          <!-- Informações Adicionais -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações Adicionais</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="driverId" class="block text-sm font-medium mb-2">
                  Motorista
                </label>
                <select 
                  id="driverId"
                  formControlName="driverId"
                  class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="">Selecione um motorista (opcional)</option>
                  <option *ngFor="let driver of drivers" [value]="driver.id">
                    {{ driver.name }} - {{ driver.email }}
                  </option>
                </select>
              </div>
              
              <div class="field">
                <label class="block text-sm font-medium mb-2">Status do Veículo</label>
                <div class="flex align-items-center">
                  <p-checkbox 
                    formControlName="active"
                    [binary]="true"
                    inputId="active" />
                  <label for="active" class="ml-2 text-sm">
                    Veículo Ativo
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensagem de Erro -->
          <div *ngIf="errorMessage" class="mb-4">
            <p-message 
              severity="error" 
              [text]="errorMessage" 
              [closable]="false" />
          </div>
        </p-card>

        <!-- Botões de Ação -->
        <div class="bg-white rounded-lg shadow-1 p-4 mt-3">
          <div class="flex justify-content-end gap-2">
            <p-button 
              label="Cancelar" 
              severity="secondary" 
              (onClick)="onCancel()"
              [disabled]="isLoading"
              icon="pi pi-times" />
            
            <p-button 
              [label]="submitButtonText"
              severity="primary"
              type="submit"
              [disabled]="isLoading || vehicleForm.invalid"
              [loading]="isLoading"
              icon="pi pi-check" />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
